import {
  Divider as CoreDivider,
  FormInputText as CoreFormInputText,
  InputLabel as CoreInputLabel,
  PhoneNumberInput as CorePhoneNumberInput,
  Select as CoreSelect,
} from '@hopskipdrive/react-components';
import { colorTokens } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const Divider = styled(CoreDivider)`
  margin: 10px 0;
`;

export const InputLabel = styled(CoreInputLabel)`
  display: flex;
  justify-content: flex-end;
  width: 25%;
  padding-right: 20px;
`;

export const FormInputText = styled(CoreFormInputText)`
  width: 50%;
  margin-left: 12px;
`;

export const Select = styled(CoreSelect)`
  width: 50%;
  margin-left: 12px;
  .MuiTextField-root {
    width: 100%;
    margin-left: 0;
  }
`;

export const PhoneNumberInput = styled(CorePhoneNumberInput)`
  width: 50%;
  margin-left: 12px;
`;

export const MarginLeft = styled.span`
  margin-left: 10px;
`;

export const CloseButton = styled('div')`
  display: inline-flex;
  margin-left: auto;
  width: 20px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;

  &:hover {
    background: #ddebfa;
    svg {
      color: ${colorTokens.text.hover};
    }
  }
`;
